export const cities = [
    {
        'id': 'AMP',
        'name': 'Amapá'
    },
    {
        'id': 'CLN',
        'name': 'Calçoene'
    },
    {
        'id': 'CTS',
        'name': 'Cutias'
    },
    {
        'id': 'FGM',
        'name': 'Ferreira Gomes'
    },
    {
        'id': 'ITB',
        'name': 'Itaubal'
    },
    {
        'id': 'LRJ',
        'name': 'Laranjal do Jari'
    },
    {
        'id': 'MCP',
        'name': 'Macapá'
    },
    {
        'id': 'MZG',
        'name': 'Mazagão'
    },
    {
        'id': 'OPQ',
        'name': 'Oiapoque'
    },
    {
        'id': 'PBA',
        'name': 'Pedra Branca do Amapari'
    },
    {
        'id': 'PGD',
        'name': 'Porto Grande'
    },
    {
        'id': 'PCB',
        'name': 'Pracuúba'
    },
    {
        'id': 'STN',
        'name': 'Santana'
    },
    {
        'id': 'SNV',
        'name': 'Serra do Navio'
    },
    {
        'id': 'TTG',
        'name': 'Tartarugalzinho'
    },
    {
        'id': 'VTJ',
        'name': 'Vitória do Jari'
    }
]
